// extracted by mini-css-extract-plugin
export default {"block":"Logo_block__s-xzz","image":"Logo_image__4XmtS"};